import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-ngx-form-validator',
  template: `
    <p>
      ngx-form-validator works!
    </p>
  `,
  styles: [
  ]
})
export class NgxFormValidatorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
